module.exports = __webpack_public_path__ + "static/media/pti.b1b58516.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/portfolios/pti.png
// module id = 293
// module chunks = 0